import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { isEqual } from "lodash";
import MenuItems from "components/layout/menu-items";

class HeaderMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeMenu: "/dashboard"
        };

        this.handleClick = this.handleClick.bind(this);

        this.menuUrls = [];
    }

    shouldComponentUpdate (nextProps, nextState) {
        if (nextState.activeMenu !== this.state.activeMenu) {
            return true;
        } else if (!isEqual(nextProps.role, this.props.role)) {
            return true;
        }
        return false;
    }

    checkUserPermission = (menuPermission) => {
        if (!Array.isArray(this.props.role) || !this.props.role.length) {
            return false;
        }

        if (!menuPermission.length) {
            return true;
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const index in menuPermission) {
            if (this.props.role.indexOf(menuPermission[index]) !== -1) {
                return true;
            }
        }
        return false;
    };

    handleClick = (activeMenu) => {
        this.setState({
            activeMenu
        });
        document.body.click();
    };

    getSubmenu = (value, level = 0) => {
        if (!this.checkUserPermission(value.permission)) {
            return null;
        }
        const activeClassName = this.state.activeMenu === value.url ? "active" : "";

        if (typeof value.visible !== "undefined" && value.visible === false) {
            return null;
        }

        if (!value.menu.length && !this.menuUrls.includes(value.url)) {
            let className = `nav-link ${activeClassName}`;
            if (level > 0) {
                className = `dropdown-item ${activeClassName}`;
            }

            if (typeof value.component === "function") {
                return (
                    <div key={this.getKeyFromName(value.name, level)}>
                        {value.component(className)}
                    </div>
                );
            } else {
                return (
                    <Link
                        key={this.getKeyFromName(value.name, level)}
                        to={value.url}
                        className={className}
                        role="button"
                        onClick={() => this.handleClick(value.url)}
                        params={value.params || {}}
                    >
                        {value.name}
                    </Link>
                );
            }
        }

        level += 1;

        const subMenuElements = value.menu.map((subValue) => this.getSubmenu(subValue, level));

        if (value.url) {
            this.menuUrls.push(value.url);
        }

        return (
            <NavDropdown
                key={this.getKeyFromName(value.name, level)}
                title={value.name}
                className="sub-menu"
            >
                {subMenuElements}
            </NavDropdown>
        );
    };

    getKeyFromName = (name, level) => `${name.split(" ").join("-")}-level${level}`;

    render () {
        return (
            <Navbar.Collapse id="header-menu">
                <Nav className="mr-auto">
                    {MenuItems.map((value) => this.getSubmenu(value))}
                </Nav>
            </Navbar.Collapse>
        );
    }
}

const mapStateToProps = state => ({
    role: state.auth.user.role,
});

export default connect(mapStateToProps)(HeaderMenu);
